import { lazy } from "react";
import {Navigate } from 'react-router-dom';

// project imports
// import Loadable from 'ui-component/Loadable';
import Loadable from "../component/Loadable/Index";
import MainLayouts from "../layout/MainLayout/index";
// login option 3 routing
const StartUsing = Loadable(
  lazy(() => import("../container/startUsing/Index"))
);
const AiApp = Loadable(lazy(() => import("../container/aiApp/Index")));
const Subscription = Loadable(lazy(() => import("../container/subscription/Index")));
const Seo = Loadable(lazy(() => import("../container/seo/Index")));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const MainLayout = {
  path: "/",
  element: <MainLayouts />,
  children: [
 
    {
      path: "/",
      element: <AiApp />,
    },
    {
      path: "/website-content-generation",
      element: <StartUsing />,
    },
    {
      path: "/article-generation",
      element: <StartUsing />,
    },
    {
      path: "/headline-generation",
      element: <StartUsing />,
    },
    {
      path: "/alt-tag-generation",
      element: <StartUsing />,
    },
    {
      path: "/meta-descriptions-generation",
      element: <StartUsing />,
    },
    {
      path: "/social-media-posts-generation",
      element: <StartUsing />,
    },
    {
      path: "/avoid-duplication",
      element: <StartUsing />,
    },
    {
      path: "/generate-faqs",
      element: <StartUsing />,
    },
    {
      path: "/your-content",
      element: <StartUsing />,
    },
    {
      path: "/summary-your-content",
      element: <StartUsing />,
    },
    {
      path: "/perform-sentiment-analysis",
      element: <StartUsing />,
    },
    {
      path: "/semantic-relevance",
      element: <StartUsing />,
    },
    {
      path: "/gather-factsand-statistics",
      element: <StartUsing />,
    },
    {
      path: "/landing-page-optimization",
      element: <StartUsing />,
    },
    {
      path: "/on-page-optimization",
      element: <StartUsing />,
    },
    {
      path: "/patterns-for-your-site-pages",
      element: <StartUsing />,
    },
    {
      path: "/rewrite-rules-for-redirects",
      element: <StartUsing />,
    },
    {
      path: "/create-your-robots-txt-rules",
      element: <StartUsing />,
    },
    {
      path: "/structured-data-for-your-content",
      element: <StartUsing />,
    },
    {
      path: "/keywords-based-on-search-intent",
      element: <StartUsing />,
    },
    {
      path: "/specify-the-source",
      element: <StartUsing />,
    },
    {
      path: "/google-search-console",
      element: <StartUsing />,
    },
    {
      path: "/lsikey-word",
      element: <StartUsing />,
    },
    {
      path: "/longtail-keywords",
      element: <StartUsing />,
    },
    {
      path: "/keyword-research",
      element: <StartUsing />,
    },
    {
      path: "/industry-specific-keywords",
      element: <StartUsing />,
    },
    {
      path: "/generate-relevant-topics-to-target",
      element: <StartUsing />,
    },
    {
      path: "/research-for-PPC",
      element: <StartUsing />,
    },
    {
      path: "/copies-generation",
      element: <StartUsing />,
    },
    {
      path: "/landing-page-optimization",
      element: <StartUsing />,
    },
    {
      path: "/on-page-optimization",
      element: <StartUsing />,
    },
    {
      path: "/patterns-for-your-site-pages",
      element: <StartUsing />,
    },
    {
      path: "/rewrite-rules-for-redirects",
      element: <StartUsing />,
    },
    {
      path: "/create-your-robots-txt-rules",
      element: <StartUsing />,
    },
    {
      path: "/structured-data-for-your-content",
      element: <StartUsing />,
    },
    {
      path: "/email-composer",
      element: <StartUsing />,
    },
    {
      path: "/reword-out-reach-emails",
      element: <StartUsing />,
    },
    {
      path: "/email-marketing-content",
      element: <StartUsing />,
    },
    {
      path: "/website-audit",
      element: <Seo/>,
    },
    {
      path: "/subscription",
      element: <Subscription />,
    },
    {
      path:"*" ,
      element:<Navigate to="/" /> 
    }
  ],
};

export default MainLayout;
